import { IGetContaPagarRateioByIdUseCase } from "../../../presentation/useCases/read/get_rateio_geral_conta_pagar_by_id_use_case";
import { RateioGeralContaPagar } from "../../models/rateio_geral_conta_pagar";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContaPagarRateioByIdUseCase
 */
export class GetContaPagarRateioByIdUseCase implements IGetContaPagarRateioByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getContaPagarRateioById(idContaPagar: number): Promise<RateioGeralContaPagar> {
    return this.repository.getContaPagarRateioById(idContaPagar);

  }
}
